<template>
  <WsMain v-if="modelData" :style="[{ 'padding-bottom': '220px' }]">
    <!-- <WsBackLabel
      @click="$router.go(-1)"
      :label="_backRouteText"
    /> -->
    <WsBreadCrumbs :items="_breadcrumbsItems"></WsBreadCrumbs>
    <WsTitle
      >{{ _title }} <span v-if="isPostVersion">{{ '(尚未發布的新版本)' }}</span></WsTitle
    >
    <!-- custom should not change default -->
    <div class="ws-button-group">
      <WsBtn
        v-if="editable"
        color="textSecondary"
        outlined
        :to="`/${modelName}/${id}/update?redirect=${this.$route.fullPath}`"
      >
        <v-icon left>mdi-pencil</v-icon> 編輯{{ _label }}
      </WsBtn>
      <WsBtn v-if="sortable" color="textSecondary" outlined @click="$_onSortOpen()">
        <v-icon left>mdi-compare-horizontal</v-icon> 變更順序
      </WsBtn>
      <WsBtn
        v-if="modeVersions && versionCreatable"
        color="textSecondary"
        outlined
        :to="`/${modelName}/${id}/version/create?redirect=${this.$route.fullPath}`"
      >
        <v-icon left>mdi-update</v-icon> 更新{{ label }}版本
      </WsBtn>
      <WsBtn v-if="modeVersions" color="textSecondary" :to="`/${modelName}/${id}/version`" outlined>
        <v-icon left>mdi-book-open-variant</v-icon> 查看版本列表
      </WsBtn>
      <WsBtn v-if="deletable" @click="$_onDelete(id)" color="deleteBtn white--text">
        <v-icon left>mdi-delete</v-icon> 刪除{{ deleteBtnText }}
      </WsBtn>
      <span v-for="(item, index) in customBtns" :key="index">
        <WsBtn
          v-if="$_checkDisplayOnModelData(item.checkDisplayOnModelData)"
          :color="item.color"
          item.type
          :outlined="item.outlined"
          :to="item.to"
          :disabled="item.disabled"
          class="ml-2"
          @click="$_onCustom(item)"
        >
          <v-icon left>{{ item.icon }}</v-icon> {{ item.title }}
        </WsBtn>
      </span>
    </div>
    <!-- </div> -->
    <!-- <WsLocalePicker
      v-if="
      localeMode"
      title="切換查看多國語言內容"
      v-model="selectingLocale"
    >
      </WsLocalePicker> -->
    <WsCallout
      v-if="isCalloutShow"
      :icon="calloutIcon"
      :title="calloutTitle"
      :remark="calloutRemark"
      :btns="calloutBtns"
      :backgroundColor="calloutBackgroundColor"
      @call-out-click="$_onCalloutClick($event)"
    />
    <div class="ws-content-section">
      <div class="ws-content-section__primary">
        <WsReadContentBlock
          v-for="(item, itemKey) in primary"
          :ref="`WsReadContentBlock_primary_${itemKey}`"
          :key="itemKey"
          :type="item.type"
          :label="item.label"
          :title="item.title"
          :remark="item.remark"
          :floors="item.floors"
          :modedFields="fields"
          :fields="item.fields"
          :activeText="item.activeText"
          :inactiveText="item.inactiveText"
          :field="item.field"
          :locale="_selectingLocale"
          :modelName="item.modelName"
          :modelVersionName="item.modelVersionName"
          :searchMode="item.searchMode"
          :batchMode="item.batchMode"
          :modeVersions="item.modeVersions"
          :modeParent="item.modeParent"
          :customButtons="item.modeVersionscustomButtons"
          :modelData="modelData"
          :modelId="id"
          :titleKey="item.titleKey"
          :fieldsRead="item.fieldsRead"
          :subVersionFields="item.subVersionFields"
          :subVersionFieldsReads="item.subVersionFieldsReads"
          :rootModelName="modelName"
          :orderBy="item.orderBy"
          :orderWay="item.orderWay"
          :parentModelName="$_getParentModelName(item)"
          :parentState="$_getParentState(item)"
          :hideOnNull="item.hideOnNull"
          :filterSelects="filterSelects"
          :showExpand="showExpand"
          :showFields="showFields"
          :tabSetting="item.tabSetting"
          :createVersion="createVersion"
          :itemVersionCreatable="itemVersionCreatable"
          :itemVersionLinkCreatable="itemVersionLinkCreatable"
          :itemVersionReadable="itemVersionReadable"
          :itemDeletable="itemDeletable"
          :itemEditable="itemEditable"
          :itemLinkCheckable="itemLinkCheckable"
          :sequenceFields="sequenceFields"
          :params="$_getParams(item)"
          :postData="$_getPostData(item)"
          :isGetAll="item.isGetAll"
          :virtualScroll="item.virtualScroll"
          :hasSequence="hasSequence"
          :hasChapters="hasChapters"
          :hasCatchVersion="hasCatchVersion"
          :customParentData="item.customParentData"
          :expandDisable="item.expandDisable"
          :filterName="filterName"
          :filterSubName="filterSubName"
          :isVersionAPI="item.isVersionAPI"
          :itemVersionReadableUrl="item.itemVersionReadableUrl"
          :batchLink="item.batchLink"
          :itemLinkEditable="item.itemLinkEditable"
          :tabItems="item.tabItems"
          :itemCreateBtnEmitAble="item.itemCreateBtnEmitAble"
          :extendPatchData="item.extendPatchData"
          :customBtns="customBtns"
          :versionModelName="versionModelName"
          :staticModelData="item.staticModelData"
          :customCreateAction="item.customCreateAction"
          :customUpdateAction="item.customUpdateAction"
          :defaultBtnDisplayFunc="item.defaultBtnDisplayFunc"
          :customUpdateSubmitAction="item.customUpdateSubmitAction"
          :customCreateSubmitAction="item.customCreateSubmitAction"
          :itemCreatable="item.itemCreatable"
          :shouldShowUpdateTag="item.shouldShowUpdateTag"
          :getUrl="item.getUrl"
          :isBatchCreateMultiLangAble="item.isBatchCreateMultiLangAble"
          :batchCreateMultiLangLink="item.batchCreateMultiLangLink"
          @created="$_onCreated($event)"
          @deleted="$_onDeleted($event)"
          @create-btn-click="$emit('create-btn-click')"
          @tab-click="$emit('tab-click', $event)"
          @custom-event="$_onCustomEvent($event)"
        ></WsReadContentBlock>
      </div>
      <div class="ws-content-section__secondary" v-if="secondary.length">
        <WsReadContentBlock
          v-for="(item, itemKey) in secondary"
          :ref="`WsReadContentBlock_secondary_${itemKey}`"
          :key="itemKey"
          :type="item.type"
          :label="item.label"
          :title="item.title"
          :remark="item.remark"
          :floors="item.floors"
          :modedFields="fields"
          :fields="item.fields"
          :activeText="item.activeText"
          :inactiveText="item.inactiveText"
          :field="item.field"
          :locale="_selectingLocale"
          :modelName="item.modelName"
          :modelVersionName="item.modelVersionName"
          :searchMode="item.searchMode"
          :batchMode="item.batchMode"
          :modeVersions="item.modeVersions"
          :modeParent="item.modeParent"
          :customButtons="item.customButtons"
          :modelData="modelData"
          :modelId="id"
          :titleKey="item.titleKey"
          :fieldsRead="item.fieldsRead"
          :orderBy="item.orderBy"
          :orderWay="item.orderWay"
          :parentModelName="$_getParentModelName(item)"
          :parentState="$_getParentState(item)"
          :hideOnNull="item.hideOnNull"
          :filterSelects="filterSelects"
          :showExpand="showExpand"
          :showFields="showFields"
          :tabSetting="item.tabSetting"
          :createVersion="createVersion"
          :itemVersionCreatable="itemVersionCreatable"
          :itemVersionLinkCreatable="itemVersionLinkCreatable"
          :itemVersionReadable="itemVersionReadable"
          :itemDeletable="itemDeletable"
          :itemEditable="itemEditable"
          :itemLinkCheckable="itemLinkCheckable"
          :sequenceFields="sequenceFields"
          :params="$_getParams(item)"
          :isGetAll="item.isGetAll"
          :virtualScroll="item.virtualScroll"
          :hasSequence="hasSequence"
          :hasChapters="hasChapters"
          :hasCatchVersion="hasCatchVersion"
          :customParentData="item.customParentData"
          :expandDisable="item.expandDisable"
          :isVersionAPI="item.isVersionAPI"
          :itemVersionReadableUrl="item.itemVersionReadableUrl"
          :batchLink="item.batchLink"
          :itemLinkEditable="item.itemLinkEditable"
          :tabItems="item.tabItems"
          :itemCreateBtnEmitAble="item.itemCreateBtnEmitAble"
          :extendPatchData="item.extendPatchData"
          :versionModelName="versionModelName"
          :staticModelData="item.staticModelData"
          :customCreateAction="item.customCreateAction"
          :customUpdateAction="item.customUpdateAction"
          :defaultBtnDisplayFunc="item.defaultBtnDisplayFunc"
          :customUpdateSubmitAction="item.customUpdateSubmitAction"
          :customCreateSubmitAction="item.customCreateSubmitAction"
          :itemCreatable="item.itemCreatable"
          :shouldShowUpdateTag="item.shouldShowUpdateTag"
          :getUrl="item.getUrl"
          :isBatchCreateMultiLangAble="item.isBatchCreateMultiLangAble"
          :batchCreateMultiLangLink="item.batchCreateMultiLangLink"
          @created="$_onCreated($event)"
          @deleted="$_onDeleted($event)"
          @create-btn-click="$emit('create-btn-click')"
          @tab-click="$emit('tab-click', $event)"
        ></WsReadContentBlock>
      </div>
    </div>
    <!-- Delete Dialog -->
    <WsAlertDialog
      ref="deleteDialog"
      title="確定要刪除嗎？"
      description="刪除後資料將無法回覆"
      @submit="$_onDeleteSubmit($event)"
    />
    <WsAlertDialog
      ref="createVersionDialog"
      :title="alertTitle"
      :description="alertDescription"
      :btnText="btnText"
      @submit="$_onDeleteSubmit($event)"
    />
    <WsSortDialog
      ref="sortDialog"
      :errorMessages="createErrorMessages"
      :title="'變更順序'"
      :modelName="modelName"
      :submodelName="submodelName"
      :modelVersionName="modelVersionName"
      :modelData="modelData"
      :hasChapters="hasChapters"
      @updateSort="$_onSortSubmit($event)"
    />
    <slot></slot>
  </WsMain>
</template>

<script>
export default {
  data: () => ({
    modelData: null,
    createErrorMessages: null,
    updateErrorMessages: null,
    updateTitle: '',
    updateFields: null,
    alertTitle: '',
    alertDescription: '',
    btnText: '',
  }),
  props: {
    titleKey: {
      type: String,
      default: 'text',
    },
    modeVersions: {
      type: Boolean,
      default: false,
    },
    versionModelName: {
      type: String,
      default: '',
    },
    backRouteText: {
      type: String,
      default: '返回',
    },
    backRoute: {
      type: String,
      default: null,
    },
    primary: {
      type: Array,
      default() {
        return [];
      },
    },
    secondary: {
      type: Array,
      default() {
        return [];
      },
    },
    id: {
      type: [String, Number],
      default: null,
    },
    localeMode: {
      type: Boolean,
      default: false,
    },
    customBtns: {
      type: Array,
      default() {
        return [];
      },
    },
    modelVersionName: {
      type: String,
      default: '',
    },
    isMultiSelect: {
      type: Boolean,
      default: false,
    },
    filterSelects: {
      type: Array,
      default: null,
    },
    showExpand: {
      type: Boolean,
      default: true,
    },
    showFields: {
      type: Array,
    },
    submodelVerisonFullName: {
      type: String,
    },
    createVersion: {
      type: Boolean,
      default: false,
    },
    editable: {
      type: Boolean,
      default: true,
    },
    sortable: {
      type: Boolean,
      default: false,
    },
    versionCreatable: {
      type: Boolean,
      defualt: false,
    },
    isFetchData: {
      type: Boolean,
      default: false,
    },
    hasSequence: {
      type: Boolean,
      default: false,
    },
    hasChapters: {
      type: Boolean,
      default: false,
    },
    isGetAll: {
      type: Boolean,
      default: false,
    },
    itemVersionLinkCreatable: {
      type: Boolean,
      default: false,
    },
    itemVersionCreatable: {
      type: Boolean,
      default: false,
    },
    itemVersionReadable: {
      type: Boolean,
      default: true,
    },
    itemDeletable: {
      type: Boolean,
      default: true,
    },
    itemEditable: {
      type: Boolean,
      default: true,
    },
    itemLinkCheckable: {
      type: Boolean,
      default: false,
    },
    sequenceFields: {
      type: [Object, Array],
    },
    backLabel: String,
    modelName: String,
    submodelName: String,
    label: String,
    fields: Object,
    hasCatchVersion: {
      type: Boolean,
      default: false,
    },
    isPostVersion: {
      type: Boolean,
      default: false,
    },
    filterName: {
      type: String,
    },
    filterSubName: {
      type: String,
    },
    staticModelData: {
      type: Function,
    },
    deletable: {
      type: Boolean,
      default: true,
    },
    getTitle: {
      type: Function,
    },
    calloutIcon: {
      type: Object,
    },
    calloutTitle: {
      type: Object,
    },
    calloutRemark: {
      type: Object,
    },
    calloutBtns: {
      type: Array,
    },
    calloutBackgroundColor: {
      type: String,
    },
    editBtnText: {
      type: String,
    },
    deleteBtnText: {
      type: String,
    },
    isCalloutShow: {
      type: Boolean,
      default: false,
    },
    multiUrl: {
      type: Function,
    },
    fetchUrl: {
      type: String,
    },
    customBreadcrumbsItems: {
      type: Array,
    },
  },
  computed: {
    _selectingLocale() {
      return this.$store.state.locale.selectingLocale;
    },
    _title() {
      if (this.getTitle) {
        return this.getTitle(this.modelData);
      }
      if (!this.modelData) {
        return this.label;
      } else if (this.modelData.name) {
        return this.modelData.name;
      } else {
        return this.$_CMS_getValueByFieldKey(this.titleKey, this.modelData);
      }
    },
    _breadcrumbsItems() {
      if (this.customBreadcrumbsItems) return this.customBreadcrumbsItems;
      const _breadcrumbsItems = [];
      _breadcrumbsItems.push({
        text: this.label,
        to: `/${this.modelName}`,
        disabled: false,
      });
      if (this._title)
        _breadcrumbsItems.push({
          text: this._title,
          disabled: true,
        });
      return _breadcrumbsItems;
    },
    _backRouteText() {
      if (this.backRouteText) {
        return '返回';
      } else {
        return `${this.label}列表`;
      }
    },
    _backRoute() {
      if (this.backRoute) {
        return this.backRoute;
      } else {
        return `/${this.modelName}`;
      }
    },
    _label() {
      return this.editBtnText ? this.editBtnText : this.label;
    },
  },
  methods: {
    $_getParams(item) {
      let _params = {};
      if (item.extendParams) {
        _params = item.extendParams(this.modelData);
      }
      //送一般params
      if (item.modeParent) {
        if (this.hasSequence || this.hasChapters || this.hasCatchVersion) {
          _params[`${this.modelName}s`] = this.modelData.id;
        }
      }
      //送版本params
      if (item.modeParentVersions) {
        if (this.hasSequence || this.hasChapters || this.hasCatchVersion) {
          _params[this.modelVersionName] = this.modelData.last_version.id;
          _params[`${this.modelVersionName}s`] = this.modelData.last_version.id;
        } else if (item.isVersionAPI) {
          _params[`${this.modelVersionName}s`] = this.modelData.last_version
            ? this.modelData.last_version.id
            : this.modelData[`${this.modelVersionName}`]
            ? this.modelData[`${this.modelVersionName}`].id
            : null;
        } else {
          _params[`${this.modelName}_version`] = this.$_getParentState(item);
        }
      }
      return _params;
    },
    $_getPostData(item) {
      let _params = {};
      if (item.modeParent) {
        if (this.hasSequence || this.hasChapters) {
          _params[`${this.modelName}s`] = this.modelData.id;
        } else {
          _params[`${this.modelName}`] = this.$_getParentState(item);
        }
      }
      if (item.modeParentVersions) {
        if (this.hasSequence || this.hasChapters) {
          _params[`${this.modelVersionName}s`] = this.modelData.last_version.id;
        } else {
          _params[`${this.modelName}_version`] = this.$_getParentState(item);
        }
      }
      return _params;
    },
    async $_onCreated($event) {
      if (this.hasSequence) {
        // has version or has no version
        try {
          let newArr = [];
          if (this.modelData.last_version.questions) {
            newArr = JSON.parse(JSON.stringify(this.modelData.last_version.questions));
          }
          newArr.push({ id: $event.id });
          await this.$axios.patch(`/${this.modelVersionName}/${this.modelData.last_version.id}`, {
            questions: newArr,
          });
          if (!this.modelData.last_version.questions) {
            this.modelData.last_version.questions = [];
          }
          // this.modelData.last_version.questions = JSON.parse(
          //   JSON.stringify(res.data.data.questions)
          // );
          this.modelData.last_version.questions.push({ id: $event.id });
        } catch (error) {
          alert(error);
        }
      }
    },
    async $_onDeleted($event) {
      if (this.hasSequence) {
        const tarIndex = this.modelData.last_version.questions.findIndex((e) => {
          return e.id == $event;
        });
        this.modelData.last_version.questions.splice(tarIndex, 1);
        let newObj = {};
        newObj.questions = JSON.parse(JSON.stringify(this.modelData.last_version.questions));
        if (newObj.questions.length) {
          newObj[`${this.submodelName}s`] = newObj.questions.map((item) => {
            return item.id;
          });
        } else {
          newObj[`${this.submodelName}s`] = [];
        }
        await this.$axios.patch(
          `/${this.modelVersionName}/${this.modelData.last_version.id}`,
          newObj,
        );
      }
    },
    $_onDelete($event) {
      this.$refs.deleteDialog.open($event);
    },
    async $_onSortOpen() {
      this.createErrorMessages = ['尚未填寫章', '尚未填寫節'];
      this.$refs.sortDialog.open();
    },
    async $_onSortSubmit(val) {
      //update api
      try {
        let newObject = {};
        if (this.hasChapters) {
          newObject.chapters = JSON.parse(JSON.stringify(val));
          newObject.chapters.forEach((chapterItem) => {
            chapterItem.sections.forEach((sectionItem) => {
              sectionItem.topics.forEach((topicItem) => {
                delete topicItem.topicTitle;
              });
            });
          });
          const getUrl = `/${this.modelVersionName}/${this.modelData.last_version.id}`;
          const res = await this.$axios.patch(getUrl, newObject);
          this.modelData.last_version.chapters = res.data.data.chapters;
        } else {
          newObject.questions = JSON.parse(JSON.stringify(val));
          newObject.questions.forEach((questionItem) => {
            delete questionItem.title;
          });
          const getUrl = `/${this.modelVersionName}/${this.modelData.last_version.id}`;
          const res = await this.$axios.patch(getUrl, newObject);
          this.modelData.last_version.questions = res.data.data.questions;
        }
        await this.$_fetchData();
      } catch (error) {
        alert(error);
      }
    },
    async $_onCustom(item) {
      if (item.emit) {
        this.$emit(item.emit, { modelData: this.modelData });
      }
    },
    async $_onDeleteSubmit($event) {
      this.$refs.deleteDialog.startLoading();
      try {
        await this.$axios.delete(`/${this.modelName}/${$event}`);
        this.$router.push(`/${this.modelName}`);
      } catch (error) {
        alert(error);
      } finally {
        this.$refs.deleteDialog.close();
      }
    },
    $_getParentState(primaryItem) {
      if (primaryItem.modeParentVersions && this.modelData.last_version) {
        return this.modelData.last_version.id;
      } else {
        return this.modelData.id;
      }
    },
    $_getParentModelName(primaryItem) {
      if (primaryItem.modeParentVersions) {
        return `${this.modelName}_version`;
      } else {
        return this.modelName;
      }
    },
    async $_fetchData() {
      this.$store.dispatch('app/startPageLoading');
      this.$store.dispatch('locale/changeLanguageAble');
      let getUrl = this.fetchUrl ? this.fetchUrl : `/${this.modelName}/${this.$route.params.id}`;
      if (this.localeMode) {
        getUrl += `?locale=${this._selectingLocale}`;
      }
      try {
        const res = await this.$axios.get(getUrl);
        this.modelData = res.data.data;
        if (this.staticModelData) {
          this.staticModelData(this.modelData, this.fields);
        }
        if (this.multiUrl) {
          const task = [];
          this.multiUrl(res.data.data).forEach((url) => {
            task.push(this.$axios.get(url));
          });
          const multiRes = await Promise.all(task);
          multiRes.forEach((result) => {
            this.modelData = { ...this.modelData, ...result.data.data };
          });
        }
        this.$emit('input', this.modelData);
      } catch (error) {
        alert(error);
      } finally {
        this.$store.dispatch('app/stopPageLoading');
      }
    },
    $_checkDisplayOnModelData(displayModelData) {
      if (!displayModelData) {
        return true;
      } else {
        return displayModelData(this.modelData);
      }
    },
    $_onCustomEvent($event) {
      this.$emit($event.customEmitEvent, { ...$event, parentId: this.modelData.last_version.id });
    },
    $_onCalloutClick($event) {
      this.$emit('call-out-click', { ...$event, modelData: this.modelData });
    },
  },
  mounted() {
    this.$_fetchData();
  },
  watch: {
    isFetchData: {
      handler() {
        this.$emit('isFetchData', !this.isFetchData);
        this.$_fetchData();
      },
    },
    id: {
      handler() {
        this.$_fetchData();
      },
    },
  },
};
</script>
